<template>
  <div class="sentence-dropdown-list">
    <span v-if="!invalidAddToGroup">
      <div class="dropdown-item scenario-action" @click="onAddToScenarioGroup()">
        {{ `${getSentenceTypePrettyName(this.type)} ${$t("sentence-list.scenario")}` }}
      </div>
      <div class="group-divider"></div>
    </span>

    <div v-for="(group, groupIndex) in currentGroups" :key="groupIndex" class="group">
      <span class="text-xs text-muted group-title">{{ group.name }}</span>

      <div v-for="(item, index) in group.group" :key="index" :ref="`listElement${groupIndex}${index}`">
        <div
          class="dropdown-item submenu create-sentence"
          @mouseover="getPosition(`${groupIndex}${index}`), (hovering = `${groupIndex}${index}`)"
          @mouseleave="hovering = null"
        >
        <div class="menu-title">
          <span class="chevron"><i class="fa-light fa-chevron-left"></i></span>        
          <span>{{ getSentenceTypePrettyName(item) }}</span>
        </div>
          <context-menu class="" v-if="hovering == `${groupIndex}${index}`" :left="subMenuPos.x" :top="subMenuPos.y">
            <div class="dropdown-item" @click="handleAdd(item, true)">
              {{ $t("sentence-list.above") }}
            </div>
            <div class="dropdown-item" @click="handleAdd(item)">
              {{ $t("sentence-list.below") }}
            </div>
          </context-menu>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContextMenu from "@/components/ContextMenu";
import { editorMixin } from "@/assets/js/editorMixin.js";
export default {
  mixins: [editorMixin],
  components: {
    ContextMenu
  },
  props: {
    sentence: Object,
    scenarioGroupNumber: Number
  },
  data() {
    return {
      hovering: null,
      subMenuPos: {
        x: null,
        y: null
      }
    };
  },
  methods: {
    getPosition(index) {
      const el = this.$refs[`listElement${index}`];
      const rect = el[0].getBoundingClientRect();
      this.$set(this.subMenuPos, "x", rect.left - 15);
      this.$set(this.subMenuPos, "y", rect.y);
    },

    handleAdd(sentenceType, before) {
      const standardCreate = ["Sentence", "Linebreak", "Sectionbreak", "NewParagraph"];
      const tableCreate = this.tableRowOptions.concat(this.tableCellOptions);
      const listCreate = ["OrderedList", "UnorderedList"];
      if (sentenceType == "Table") {
        this.$emit("on-create-table", before);
      } else if (sentenceType == "ListItem") {
        this.$emit("on-create-list-item", sentenceType, before);
      } else if (listCreate.includes(sentenceType)) {
        this.$emit("on-create-list", sentenceType, before);
      } else if (tableCreate.includes(sentenceType)) {
        before
          ? this.$emit("on-create-table-element-before", sentenceType)
          : this.$emit("on-create-table-element-after", sentenceType);
      } else if (standardCreate.includes(sentenceType)) {
        before
          ? this.$emit("on-create-scenariogroup-before", sentenceType)
          : this.$emit("on-create-scenariogroup-after", sentenceType);
      }
    },

    onAddToScenarioGroup() {
      let sentenceType;
      if (!this.type || this.type == undefined || this.type == null) {
        sentenceType = "Sentence";
      } else sentenceType = this.type;
      this.$emit("on-add-scenario-to-group", sentenceType);
    }
  },
  computed: {
    sectionHasParagraphOptions() {
      return this.$store.state.templateSectionBeingEdited.paragraph;
    },
    currentGroups() {
      if (this.isListItem) return [this.listGroups];
      if (this.isTableHeader || this.isTableRow) return [this.tableRowGroups];
      else if (this.isTableCell) return [this.tableCellGroups];
      else return this.standardGroups;
    },
    type() {
      return this.sentence ? this.sentence.sentenceType : null;
    },
    isTableHeader() {
      return this.type === "TableHeaderRow";
    },
    isTableRow() {
      return this.type === "TableRow";
    },
    isTableCell() {
      return ["TableCell", "TableHeaderCell"].includes(this.type);
    },
    isListItem() {
      return this.type === "ListItem";
    },
    tableRowOptions() {
      return ["TableHeaderRow", "TableRow"];
    },
    tableCellOptions() {
      return ["TableHeaderCell", "TableCell"];
    },
    listOptions() {
      return ["ListItem"];
    },
    invalidAddToGroup() {
      return ["Sectionbreak", "Linebreak", "NewParagraph"].includes(this.type);
    },
    topLevelScenarioType() {
      return [
        "Sectionbreak",
        "Linebreak",
        "NewParagraph",
        "Table",
        "UnorderedList",
        "OrderedList",
        "Sentence",
        null,
        undefined
      ].includes(this.type);
    },

    // groups

    standardGroup() {
      return {
        name: "Standard",
        group: ["Sentence"]
      };
    },

    breakGroup() {
      let breakGroup = {
        name: "Breaks",
        group: ["Linebreak", "Sectionbreak"]
      };
      if (this.sectionHasParagraphOptions) breakGroup.group.push("NewParagraph");
      return breakGroup
    },

    specialGroup() {
      return {
        name: "Special",
        group: ["Table", "UnorderedList", "OrderedList"]
      };
    },
    listGroups() {
      return {
        name: "List",
        group: this.listOptions
      };
    },
    tableRowGroups() {
      return {
        name: "Table row",
        group: this.tableRowOptions
      };
    },
    tableCellGroups() {
      return {
        name: "Table cell",
        group: this.tableCellOptions
      };
    },
    standardGroups() {
      return [this.standardGroup, this.breakGroup, this.specialGroup];
    }
  }
};
</script>

<style lang="less">
.sentence-dropdown-list {
  .scenario-action {
    margin-bottom: 6px;
    &::before {
      content: "+";
    }
  }
  .menu-title{
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .chevron{
    font-size: 8px;
  }
  .group {
    position: relative;
    margin: 0;
    padding-top: 0px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 4px;
    border-top: 1px solid var(--text-grey-primary);
  }
  .group-title {
    align-self: start;
    font-size: 12px;
    font-weight: 400;
    padding: 0px 12px;
  }
}
</style>
